export default "__VITE_ASSET__ZYS1pi03__";